import React, { useState, useEffect, useRef } from "react";
import "../styles/pages/Making.scss";
import ArrowButton from "../components/utils/button/ArrowButton";
import { useNavigate, useLocation } from "react-router-dom";

import FinalReadingModal from "../components/reading/FinalReadingModal";
import LandScapeModal from "../components/utils/modal/LandScapeModal";
import {
  logStorylandReading,
  generateTTS,
  getBookContents,
  getStoryLandBookInfo,
} from "../api/LibraryAPI";
import ErrorModal from "../components/utils/modal/ErrorModal";
import { ERROR } from "../utils/Constants";
import StoryImage from "../components/utils/StoryImage";
import StoryContentToggle from "../components/utils/StoryContentToggle";
import AudioBookCreationModal from "../components/audiobook/AudioBookCreationModal";
import Flipbook from "../components/flipbook/Flipbook";
import NovelFrame from "../components/flipbook/NovelFrame";
import "../styles/components/selectbook/Result.scss";
import { getLocalizedAssetPath } from "../utils/getLocalizedLogo";

const Reading = () => {
  const location = useLocation();

  const USER_ID = localStorage.getItem("userID");
  const BOOK_ID = localStorage.getItem("book_id");

  console.log("BOOK_ID", BOOK_ID);

  const pageName = location.state?.pageName ?? "";
  // const stateBookID = location.state?.bookID; // 라우터 state
  const stateBookID =
    location.state?.bookList?.book_id ?? location.state?.bookID ?? null;
  const lsBookID = localStorage.getItem("book_id");
  const bookID = stateBookID ?? lsBookID ?? "";

  console.log("stateBookID", stateBookID);
  console.log("lsBookID", lsBookID);
  console.log("bookID??!!", bookID);

  const [bookData, setBookData] = useState(null);
  const [story, setStory] = useState([]);

  console.log("Location:", location);
  console.log("pageName:", pageName, "bookID:", bookID);

  const [index, setIndex] = useState(-1);
  const [showFinalReadingModal, setShowFinalReadingModal] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [bgImage, setBgImage] = useState("");
  const [contentText, setContentText] = useState([]);
  const [speechState, setSpeechState] = useState(false);
  const [audioCache, setAudioCache] = useState({});
  const [imageSrc, setImageSrc] = useState("/images/utils/button/music-on.svg");
  const [currentAudioIndex, setCurrentAudioIndex] = useState(null);

  // 오디오북 관련 상태
  const [showAudioModal, setShowAudioModal] = useState(false);
  const [isFlipping, setIsFlipping] = useState(false);
  const [isBookOpened, setIsBookOpened] = useState(false);
  const [showFlipbook, setShowFlipbook] = useState(false);
  const [showTitleOnCover, setShowTitleOnCover] = useState(true);

  const audioRef = useRef(new Audio());
  const fetchingRef = useRef({});

  const navigate = useNavigate();

  // 테스트중
  const callBookContentsAPI = async (book_id, isStoryland = false) => {
    console.log("book_id------>>>>>", book_id);
    const res = isStoryland
      ? await getStoryLandBookInfo(book_id)
      : await getBookContents(book_id);

    console.log("res!!!!!!", res);

    if (res.success) {
      const raw = res.data;
      const book = Array.isArray(raw) ? raw[0] : raw;

      console.log("boook?", book);

      setBookData(book);
      setStory(book.contents_json?.story || []);
      setBgImage(book.bookcover);
      setContentText(book.title);
    } else {
      setErrorMessage(ERROR.lack);
      setShowErrorModal(true);
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      const isStoryland = pageName === "storyland";

      // 스토리랜드 로그 기록
      if (isStoryland) {
        const res = await logStorylandReading(USER_ID, bookID);
        if (!res.success) {
          setErrorMessage(ERROR.lack);
          setShowErrorModal(true);
          return;
        }
      }

      // 책 내용 불러오기
      await callBookContentsAPI(bookID, isStoryland);

      if (location.state?.makeAudioBook) {
        setShowAudioModal(true);
      }
    };

    fetchData();
  }, []);

  const fetchTTS = async (pageIndex) => {
    if (audioCache[pageIndex] || fetchingRef.current[pageIndex]) return;

    fetchingRef.current[pageIndex] = true;
    let textContent =
      pageIndex === -1 ? bookData.title : story[pageIndex]?.page_content || "";

    try {
      const response = await generateTTS(USER_ID, textContent, "vdain", 0);
      if (response.success) {
        const audioBlob = new Blob([response.data], {
          type: "audio/mpeg",
        });
        const audioURL = URL.createObjectURL(audioBlob);
        setAudioCache((prev) => ({ ...prev, [pageIndex]: audioURL }));
      } else {
        console.error("TTS API 오류");
      }
    } catch (error) {
      console.error("TTS 요청 오류:", error);
    } finally {
      fetchingRef.current[pageIndex] = false;
    }
  };

  const handleButtonClick = (direction) => {
    setIndex((prevIndex) => {
      let newIndex = prevIndex + (direction === "left" ? -1 : 1);
      if (newIndex < -1) {
        return prevIndex;
      } else if (newIndex >= story.length) {
        setShowFinalReadingModal(true);
        return prevIndex;
      }
      return newIndex;
    });
  };

  const handleSpeechState = () => {
    if (!speechState) {
      setImageSrc("/images/utils/button/music-off.svg");
      if (!audioCache[index]) fetchTTS(index);
    } else {
      audioRef.current.pause();
      setImageSrc("/images/utils/button/music-on.svg");
    }
    setSpeechState((prev) => !prev);
  };

  useEffect(() => {
    if (!bookData) return;

    if (index === -1) {
      setBgImage(bookData.bookcover);
      setContentText(bookData.title);
      setShowFinalReadingModal(false);
    } else {
      setBgImage(story[index]?.background || "");
      let contents = story[index]?.page_content || "";
      if (contents.includes("\\")) contents = contents.replaceAll("\\", "");
      const sentences = contents
        .split(". ")
        .map((s) => s.trim())
        .filter((s) => s.length > 0)
        .map((s) => (s.endsWith(".") ? s : s + "."));
      setContentText(sentences);
    }

    if (speechState) {
      if (!audioCache[index]) fetchTTS(index);
      if (index + 1 < story.length && !audioCache[index + 1])
        fetchTTS(index + 1);
    }
  }, [index, bookData]);

  useEffect(() => {
    if (speechState && audioCache[index] && index !== currentAudioIndex) {
      audioRef.current.pause();
      audioRef.current.src = audioCache[index];
      audioRef.current
        .play()
        .then(() => {
          setCurrentAudioIndex(index);
        })
        .catch((error) => console.error("Audio play error:", error));
    }
  }, [audioCache, index, speechState]);

  useEffect(() => {
    return () => {
      try {
        audioRef.current?.pause();
      } catch {}
      if (audioRef.current) {
        audioRef.current.src = "";
      }
    };
  }, []);

  const handleAudioEnd = () => {
    setImageSrc("/images/utils/button/music-off.svg");
  };

  const handleExit = () => {
    setAudioCache({});
    setShowFinalReadingModal(false);
  };

  console.log("책 정보----->>>>>>", bookData);

  return (
    <>
      {bookData?.style === "graphic_novel" ||
      bookData?.style === "그림 소설" ? (
        <NovelFrame
          isFlipping={isFlipping}
          showLogo={false}
          isOpened={showFlipbook}
        >
          {showFlipbook ? (
            <div className="flipbook-fade-in-wrapper">
              <Flipbook
                index={index}
                story={story}
                setStory={setStory}
                pageCount={story.length}
                setShowFinalModal={setShowFinalReadingModal}
                setIsFlipping={setIsFlipping}
                handleChangeBackground={null}
                setIndex={setIndex}
                isReadOnly={true}
                title={bookData?.title}
                cover={bookData?.bookcover}
              />
            </div>
          ) : (
            /* 책장 표지 오버레이 */
            <div
              className={`book-shelf-cover ${isBookOpened ? "opened" : ""}`}
              onClick={() => {
                if (isBookOpened) return;
                setIsBookOpened(true);
                setTimeout(() => {
                  setShowFlipbook(true);
                  setIndex(0); // 책을 펼치면 첫 페이지(0)로 설정
                }, 600); // Result.scss의 transition 시간과 맞춤
              }}
            >
              <div className="result-book-container">
                <div className="result-book">
                  <div className="cover-content">
                    <div className="cover-title-toggle-tabs">
                      <button
                        className={`toggle-tab ${showTitleOnCover ? "active" : ""}`}
                        onClick={(e) => {
                          e.stopPropagation();
                          setShowTitleOnCover(true);
                        }}
                      >
                        <img
                          src={
                            showTitleOnCover
                              ? getLocalizedAssetPath("/images/makingBranch/title-on.svg")
                              : getLocalizedAssetPath("/images/makingBranch/title-off.svg")
                          }
                          alt="제목 보기"
                          loading="lazy"
                          decoding="async"
                        />
                      </button>
                      <button
                        className={`toggle-tab ${!showTitleOnCover ? "active" : ""}`}
                        onClick={(e) => {
                          e.stopPropagation();
                          setShowTitleOnCover(false);
                        }}
                      >
                        <img
                          src={
                            showTitleOnCover
                              ? getLocalizedAssetPath("/images/makingBranch/cover-off.svg")
                              : getLocalizedAssetPath("/images/makingBranch/cover-on.svg")
                          }
                          alt="표지 보기"
                          loading="lazy"
                          decoding="async"
                        />
                      </button>
                    </div>
                    <img
                      src={bookData?.bookcover}
                      alt="cover"
                      loading="lazy"
                      decoding="async"
                    />
                    <h2
                      className={`novel-title ${!showTitleOnCover ? "hide" : ""}`}
                    >
                      {bookData?.title}
                    </h2>
                  </div>
                </div>
                <figure className="result-book-left">
                  <img
                    src="/images/utils/modal/novelFinalModal/book-left.svg"
                    alt="spine"
                    loading="lazy"
                    decoding="async"
                  />
                </figure>
                <figure className="result-book-bottom">
                  <img
                    src="/images/utils/modal/novelFinalModal/book-bottom.svg"
                    alt="pages"
                    loading="lazy"
                    decoding="async"
                  />
                </figure>
              </div>
            </div>
          )}
        </NovelFrame>
      ) : (
        <section className="stories-section">
          {showErrorModal && (
            <ErrorModal
              error_message={errorMessage}
              onClose={() => {
                setShowErrorModal(false);
                navigate("/storyland");
              }}
            />
          )}
          <StoryImage src={bgImage} alt="bg-img" />
          <StoryContentToggle
            showTitleOnCover={showTitleOnCover}
            setShowTitleOnCover={setShowTitleOnCover}
          />
          <div className="story-ui-layer">
            <ArrowButton
              onClick={() => handleButtonClick("left")}
              direction="left"
              className="story-btn prev-btn"
            />
            <ArrowButton
              onClick={() => handleButtonClick("right")}
              direction="right"
              className="story-btn next-btn"
            />
            <div
              className={`${
                typeof contentText === "string"
                  ? "story-contents-container title"
                  : "story-contents-container"
              } ${!showTitleOnCover ? "hide" : ""}`}
            >
              <ul
                className={
                  typeof contentText === "string"
                    ? "story-contents title"
                    : "story-contents"
                }
              >
                {typeof contentText === "string" ? (
                  <>
                    {contentText}
                    <div className="text-stroke">{contentText}</div>
                  </>
                ) : Array.isArray(contentText) ? (
                  <>
                    {contentText.map((sentence, i) => (
                      <li key={i} className="origin-text">
                        {sentence.trim()}
                        <div className="text-stroke">{sentence.trim()}</div>
                      </li>
                    ))}
                  </>
                ) : null}
              </ul>
            </div>
            <button
              onClick={(e) => {
                e.stopPropagation();
                handleSpeechState();
              }}
              className="text-music-btn"
            >
              <img
                src={imageSrc}
                alt="음성 듣기 버튼"
                loading="lazy"
                decoding="async"
              />
            </button>
            <div className="numbering">{index + 1}</div>
          </div>
          <audio ref={audioRef} onEnded={handleAudioEnd} />
        </section>
      )}
      {showFinalReadingModal && (
        <FinalReadingModal
          onBack={() => window.location.reload()}
          pageName={pageName}
          onClose={handleExit}
          isAudio={false}
        />
      )}
      {showAudioModal && (
        <AudioBookCreationModal
          bookData={bookData}
          userID={USER_ID}
          onClose={() => setShowAudioModal(false)}
        />
      )}
      <LandScapeModal />
    </>
  );
};

export default Reading;
